import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-complete-order',
  templateUrl: './complete-order.component.html',
  styleUrls: ['./complete-order.component.scss'],
})
export class CompleteOrderComponent implements AfterViewInit {
  constructor(
    public viewOffersService: ViewOffersService,
    public additionalServicesService: AdditionalServicesService,
    public completeOrderService: CompleteOrderService
  ) {}

  ngAfterViewInit(): void {
    this.viewOffersService.scrollIntoView('header', 'smooth');
  }
}
